<template>

  <alert-template @close="$emit('close', $event)">
    <div slot="title">{{error.message}}</div>
    <div slot="message">{{error.response.error.message}}</div>
    <div slot="more"><pre>{{error.response.error.stack}}</pre></div>
  </alert-template>

</template>

<script>
import alertTemplate from "@/_components/layouts/alert-template"

export default {
  name: 'AlertHttp',
  props : {
    error : {type:Error, default:() => null}
  },
  components : {alertTemplate},
  computed : {},
  data()
  {
    return {
    }
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
</style>
